import { ActionHandler } from 'action-handler';

const KEY_PREFIX = 'loadingrateapp:';

export const getLoadingValue = (state, id) =>
  state.rateAppLoading[`${KEY_PREFIX}${id}`];

export default new ActionHandler({
  name: 'setLoadingRateApp',
  defaultState: {
    rateAppLoading: {}
  },
  handler: (id, loading) => {
    const key = `${KEY_PREFIX}${id}`;

    return {
      key,
      loading
    };
  },
  reduce(state, { key, loading }) {
    return {
      rateAppLoading: {
        ...state.rateAppLoading,
        [key]: loading || undefined
      }
    };
  }
});
